<template>
  <div class="container-xxl-fluid">
    <div class="row">
      <div class="col-lg-12 d-flex flex-column">
        <SalesPersonTargetBar></SalesPersonTargetBar>
      </div>
      <div class="col-lg-6 d-flex flex-column">
        <AylikCiroGrafigi
            style="flex-grow: 1;
  display: flex;"
            :dashboard-filter-current-code-prop="user.userInfo.erpCode"
            :dashboard-filter-sales-person-code-prop="user.SalesPersonCode"
            :view-type="'table'"
        ></AylikCiroGrafigi>
      </div>
      <div class="col-lg-6 d-flex flex-column">
        <EnIyiSatis
            style="flex-grow: 1;
  display: flex;"
            :dashboard-filter-current-code-prop="user.userInfo.erpCode"
            :dashboard-filter-sales-person-code-prop="
            user.SalesPersonCode
          "
        ></EnIyiSatis>
      </div>
      <div class="col-lg-12">
        <EnIyiSatilanUrunler
            :title="'En İyi Stoklar'"
            :dashboard-filter-current-code-prop="user.userInfo.erpCode"
            :dashboard-filter-sales-person-code-prop="user.SalesPersonCode"
            :view-type="'table'"
        ></EnIyiSatilanUrunler>
      </div>
      <div class="col-lg-12">
        <Top10Cari
            :title="'Top Cari'"
            :dashboard-filter-current-code-prop="user.userInfo.erpCode"
            :dashboard-filter-sales-person-code-prop="user.SalesPersonCode"
        ></Top10Cari>
      </div>
      <div class="col-lg-12">
        <PlasiyerTahsilatAnaliz
            :title="'Tahsilat Analiz'"
            :dashboard-filter-current-code-prop="user.userInfo.erpCode"
            :dashboard-filter-sales-person-code-prop="user.SalesPersonCode"
        ></PlasiyerTahsilatAnaliz>
      </div>
      <div class="col-lg-12">
        <PlasiyerTahsilatAnalizDetay
            :title="'Tahsilat Analiz Detay'"
            :dashboard-filter-current-code-prop="user.userInfo.erpCode"
            :dashboard-filter-sales-person-code-prop="user.SalesPersonCode"
        ></PlasiyerTahsilatAnalizDetay>
      </div>

    </div>
  </div>
</template>

<script>

import PlasiyerTahsilatAnalizDetay
  from "@/components/dashboard/PlasiyerTahsilatAnalizDetay/PlasiyerTahsilatAnalizDetay";
import PlasiyerTahsilatAnaliz from "@/components/dashboard/PlasiyerTahsilatAnaliz/PlasiyerTahsilatAnaliz";
import Top10Cari from "@/components/dashboard/Top10Cari/Top10Cari";
import EnIyiSatilanUrunler from "@/components/dashboard/EnIyiSatilanUrunler/EnIyiSatilanUrunler";
import {mapActions, mapState} from "vuex";
import AylikCiroGrafigi from "@/components/dashboard/AylikCiroGrafigi/AylikCiroGrafigi";
import EnIyiSatis from "@/components/dashboard/EnIyiSatis/EnIyiSatis.vue";
import SalesPersonTargetBar from "@/components/dashboard/PlasiyerHedef/SalesPersonTargetBar.vue";

export default {
  name: "SalesPersonDashboard",
  components: {
    SalesPersonTargetBar,
    EnIyiSatis,
    AylikCiroGrafigi,
    PlasiyerTahsilatAnalizDetay,
    PlasiyerTahsilatAnaliz,
    EnIyiSatilanUrunler,
    Top10Cari
  },
  computed: {
    ...mapState("auth", ["user"])
  },
  mounted(){
    this._fetchCompanyTotalInfoReport();
  },
  methods:{
    ...mapActions("currencies", ["setDollar", "setEuro", "setPound"]),
    ...mapActions("dashboard", ["fetchCompanyTotalInfoReport"]),
      _fetchCompanyTotalInfoReport(){
      this.reportCompanyDataLoading = true;
      this.fetchCompanyTotalInfoReport({
        params: {
          userId: this.user.UserId,
          salesPersonCode: this.user.salesPersonCode,
          ...(!(this.dashboardFilterCurrentCodeProp === "" || this.dashboardFilterCurrentCodeProp == null)) && {currentCode: this.dashboardFilterCurrentCodeProp},
          ...(!(this.dashboardFilterReportDbNameProp === "" || this.dashboardFilterReportDbNameProp == null)) && {reportDbName: this.dashboardFilterReportDbNameProp}
        },
        body: {}
      }).then((result) => {
        if(result && result.data.success){
          this.reportCompanyData = result.data.data;
          this.setDollar(result.data.data.dollar);
          this.setEuro(result.data.data.euro);
          this.setPound(result.data.data.pound);
        }
        this.reportCompanyDataLoading = false;
      })
    }
  },
}
</script>
